/* eslint-disable */
import { useEffect, useState } from "react";
import { Tabs, Tab, Box, Typography, Grid } from "@mui/material";
import { Search, Visibility, Star, SearchOff } from "@mui/icons-material";
import { styled } from "@mui/system";
import BarChartIcon from "@mui/icons-material/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AveragePosition from "./AveragePosition";
import TrafficForecast from "./TrafficForecast";
import SearchVisibility from "./SearchVisibility";
import SerpFeature from "./SerpFeature";
import InTopTen from "./InTopTen";
import SelectedKeywords from "./SelectedKeywords";
import { useMemo } from "react";

const BoxWrapper = styled(Box)(({ theme }) => ({
  marginTop: "30px",
  "& .mainHead": {
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "1",
    textAlign: "left",
    marginBottom: "23px",
    color: theme.palette.text.primary,
  },
  "& .tabsWrapper": {
    "& .tabsInner": {
      "& .MuiTabs-flexContainer": {
        justifyContent: "space-between",
        [theme.breakpoints.down("sm")]: {
          justifyContent: "flex-start",
        },
      },
      "& .MuiTab-root": {
        minWidth: 182,
        display: "flex",
        flexDirection: "column",
        textTransform: "none",
        color: theme.palette.text.primary,
        padding: "15px 20px",
        [theme.breakpoints.down("sm")]: {
          padding: "10px",
          minWidth: "auto",
        },
      },
      "& .Mui-selected": {
        color: theme.palette.primary.main,
        fontWeight: "bold",
        border: `1px solid ${theme.palette.primary.main} !important`,
        borderRadius: "8px",
        "& .innerContent": {
          "& p": {
            color: `${theme.palette.primary.main} !important`,
          },
          "& span": {
            color: `${theme.palette.primary.main} !important`,
          },
        },
      },
      "& .innerBoxWrapper": {
        width: "100%",
        "& .tabIcon": {
          textAlign: "left",
          "@media screen and (max-width:600px)": {
            textAlign: "center",
          },
        },
        "& .innerContent": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "10px",
          marginTop: "10px",
          [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            gap: "5px",
          },
          "& p": {
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "1",
            textAlign: "left",
            color: theme.palette.mode === "dark" ? "#ffffff" : "#7687A3",
          },
          "& span": {
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: "25.2px",
            textAlign: "left",
            color: theme.palette.text.primary,
          },
        },
      },
      "& button": {
        borderRight: "1px solid #D7D7D7",
        "&:last-of-type": {
          border: "none",
        },
        "&:focus": {
          outline: "none",
        },
      },
    },
  },
}));

function GoogleIndia({ rankingData, checkedRows, maxActiveIcons }) {
  const [activeTab, setActiveTab] = useState(0);
  const latestData = useMemo(() => {
    return rankingData?.averageGraphData?.[rankingData.averageGraphData.length - 1] || {};
  }, [rankingData]);

  const tabData = [
    {
      label: "Average position",
      value: latestData?.averageRank ?? "00",
      icon: <BarChartIcon />,
      content: <AveragePosition rankingData={rankingData} />,
    },
    { label: "Traffic forecast", value: latestData?.trafficForecast ?? "00", icon: <TrendingUpIcon />, content: <TrafficForecast rankingData={rankingData} /> },
    { label: "Search visibility", value: latestData?.searchVisibility ?? "00", icon: <Visibility />, content: <SearchVisibility rankingData={rankingData} /> },
    // { label: "SERP features", value: maxActiveIcons, icon: <SearchOff />, content: <SerpFeature rankingData={rankingData} /> },
    { label: "% in Top 10", value: latestData?.rankBelow10Percentage ?? "00", icon: <Star />, content: <InTopTen rankingData={rankingData} /> },
    {
      label: "Selected keywords",
      value: Object.values(checkedRows).filter(row => row?.checked).length || 0,
      icon: <Search />,
      content: <SelectedKeywords checkedRows={checkedRows} />,
    },
  ];
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <BoxWrapper>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography className="mainHead" component="h2">
            Google - India
          </Typography>
        </Grid>
      </Grid> */}
      <Box className="tabsWrapper">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          className="tabsInner"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: { backgroundColor: "transparent" },
          }}
        >
          {tabData.map((tab, index) => (
            <Tab
              key={tab}
              label={
                <Box className="innerBoxWrapper">
                  <Box className="tabIcon">{tab.icon}</Box>
                  <Box className="innerContent">
                    <Typography component="p">{tab.label}</Typography>
                    <Typography component="span">{tab.value}</Typography>
                  </Box>
                </Box>
              }
            />
          ))}
        </Tabs>
        <Box className="tabContent">
          <Typography variant="body1">{tabData[activeTab].content}</Typography>
        </Box>
      </Box>
    </BoxWrapper>
  );
}

export default GoogleIndia;
